import { css } from "lit";

export const checkboxStyles = css`
  :host {
    display: inline-block;
    -webkit-tap-highlight-color: transparent;
    outline: 0;
  }

  .cds-checkbox__checkbox {
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    white-space: normal;
    vertical-align: middle;
    width: 100%;
  }
  .cds-checkbox__checkbox .cds-checkbox__container {
    box-sizing: border-box;
    display: inline-block;
    position: relative;
    width: var(--token-global-spacing-s20, 20px);
    height: var(--token-global-spacing-s20, 20px);
    flex-shrink: 0;
  }
  .cds-checkbox__checkbox .cds-checkbox__container .cds-checkbox__square {
    box-sizing: border-box;
    height: var(--token-global-spacing-s20, 20px);
    left: 0;
    position: absolute;
    top: 0;
    width: var(--token-global-spacing-s20, 20px);
    border: 1px solid var(--token-component-checkbox-empty-default-border, light-dark(#83838c, #696970));
    background: var(--token-component-checkbox-empty-default-background, light-dark(#ffffff, #3d3d42));
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .cds-checkbox__checkbox
    .cds-checkbox__container
    .cds-checkbox__square
    .cds-icon {
    color: var(--token-component-checkbox-checked-default-icon, light-dark(#ffffff, #343438));
  }
  .cds-checkbox__checkbox .cds-checkbox__container input {
    bottom: 0;
    left: 50%;
  }
  .cds-checkbox__checkbox .cds-checkbox__label-content {
    -webkit-user-select: auto;
    -moz-user-select: auto;
    -ms-user-select: auto;
    user-select: auto;
    display: inline-block;
    order: 0;
    line-height: var(--token-global-font-line-height-xxxs, 1rem); /* 16px */
    padding-left: var(--token-global-spacing-s8, 8px);
    font-weight: var(--token-global-font-font-weight-regular-normal, 400);
    font-size: var(--token-global-font-font-size-xs, 0.875rem); /* 14px */
    color: var(--token-component-checkbox-empty-default-text, light-dark(#343438, #ffffff));
  }
  .cds-checkbox__checkbox .cds-checkbox__label-content:empty {
    padding-left: 0;
  }
  .cds-checkbox__checkbox:hover .cds-checkbox__label-content {
    color: var(--token-component-checkbox-empty-hover-text, light-dark(#343438, #ffffff));
  }
  .cds-checkbox__checkbox.checkbox--checked:hover
    .cds-checkbox__label-content {
    color: var(--token-component-checkbox-checked-hover-text, light-dark(#343438, #ffffff));
  }
  .cds-checkbox__checkbox.checkbox--checked.checkbox--disabled:hover
    .cds-checkbox__label-content {
    color: var(--token-component-checkbox-checked-disabled-text, light-dark(#a3a3ab, #83838c));
  }
  .cds-checkbox__checkbox.checkbox--checked.checkbox--readonly:hover
    .cds-checkbox__label-content {
    color: var(--token-component-checkbox-checked-read-only-text, light-dark(#343438, #ffffff));
  }
  .cds-checkbox__checkbox.checkbox--indeterminate:hover
    .cds-checkbox__label-content {
    color: var(--token-component-checkbox-indeterminated-hover-text, light-dark(#343438, #ffffff));
  }
  .cds-checkbox__checkbox.checkbox--indeterminate.checkbox--disabled:hover
    .cds-checkbox__label-content {
    color: var(--token-component-checkbox-indeterminated-disabled-text, light-dark(#a3a3ab, #83838c));
  }
  .cds-checkbox__checkbox.checkbox--indeterminate.checkbox--readonly:hover
    .cds-checkbox__label-content {
    color: var(--token-component-checkbox-indeterminated-read-only-text, light-dark(#343438, #ffffff));
  }
  .cds-checkbox__checkbox.checkbox--disabled .cds-checkbox__label-content {
    color: var(--token-component-checkbox-empty-disabled-text, light-dark(#a3a3ab, #83838c));
    cursor: not-allowed;
  }
  .cds-checkbox__checkbox.checkbox--readonly .cds-checkbox__label-content {
    color: var(--token-component-checkbox-empty-read-only-text, light-dark(#343438, #ffffff));
  }
  .cds-checkbox__checkbox:not(.checkbox--disabled):not(
      .checkbox--readonly
    ).checkbox--checked:hover
    .cds-checkbox__label-content {
    color: var(--token-component-checkbox-checked-hover-text, light-dark(#343438, #ffffff));
  }
  .cds-checkbox__checkbox:not(.checkbox--disabled):not(
      .checkbox--readonly
    ).checkbox--checked:active
    .cds-checkbox__label-content {
    color: var(--token-component-checkbox-checked-active-text, light-dark(#343438, #ffffff));
  }
  .cds-checkbox__checkbox.checkbox--indeterminate:hover
    .cds-checkbox__square {
    background: var(--token-component-checkbox-indeterminated-hover-background, light-dark(#009cde, #96cff0));
  }
  .cds-checkbox__checkbox.checkbox--indeterminate:active
    .cds-checkbox__square {
    background: var(--token-component-checkbox-indeterminated-active-background, light-dark(#0174bc, #5bb3ea));
  }
  .cds-checkbox__checkbox.checkbox--disabled
    .cds-checkbox__container
    .cds-checkbox__square {
    cursor: not-allowed;
    color: var(--token-component-checkbox-empty-disabled-text, light-dark(#a3a3ab, #83838c));
  }
  .cds-checkbox__checkbox.checkbox--disabled
    .cds-checkbox__container
    .cds-checkbox__square
    .cds-icon {
    color: var(--token-component-checkbox-checked-disabled-icon, light-dark(#ffffff, #ffffff));
  }
  .cds-checkbox__checkbox.checkbox--readonly:not(.checkbox--disabled) {
    cursor: not-allowed;
  }
  .cds-checkbox__checkbox.checkbox--disabled
    .cds-checkbox__container
    .cds-checkbox__square {
    border-color: var(--token-component-checkbox-empty-disabled-border, light-dark(#c2c2ca, #515157));
    background-color: var(--token-component-checkbox-empty-disabled-background, light-dark(#e5e5ea, #515157));
  }
  .cds-checkbox__checkbox.checkbox--readonly
    .cds-checkbox__container
    .cds-checkbox__square {
    border-color: var(--token-component-checkbox-empty-read-only-border, light-dark(#c2c2ca, #515157));
  }
  .cds-checkbox__checkbox.checkbox--readonly
    .cds-checkbox__container
    .cds-checkbox__square
    .cds-icon {
    cursor: not-allowed;
    color: var(--token-component-checkbox-checked-read-only-icon, light-dark(#a3a3ab, #83838c));
  }
  .cds-checkbox__checkbox.checkbox--checked
    .cds-checkbox__container
    .cds-checkbox__square {
    border-color: var(--token-component-checkbox-checked-default-background, light-dark(#0174bc, #5bb3ea));
    background: var(--token-component-checkbox-checked-default-background, light-dark(#0174bc, #5bb3ea));
  }
  .cds-checkbox__checkbox.checkbox--indeterminate
    .cds-checkbox__container
    .cds-checkbox__square {
    border-color: var(--token-component-checkbox-indeterminated-default-background, light-dark(#0174bc, #5bb3ea));
    background: var(--token-component-checkbox-indeterminated-default-background, light-dark(#0174bc, #5bb3ea));
  }
  .cds-checkbox__checkbox.checkbox--checked.checkbox--disabled
    .cds-checkbox__container
    .cds-checkbox__square {
    border-color: var(--token-component-checkbox-checked-disabled-background, light-dark(#afdef8, #515157));
    background: var(--token-component-checkbox-checked-disabled-background, light-dark(#afdef8, #515157));
  }
  .cds-checkbox__checkbox.checkbox--checked.checkbox--readonly
    .cds-checkbox__container
    .cds-checkbox__square {
    border-color: var(--token-component-checkbox-checked-read-only-border, light-dark(#c2c2ca, #515157));
    background: var(--token-component-checkbox-checked-read-only-background, light-dark(#ffffff, #3d3d42));
  }
  .cds-checkbox__checkbox.checkbox--indeterminate.checkbox--disabled
    .cds-checkbox__container
    .cds-checkbox__square {
    border-color: var(--token-component-checkbox-indeterminated-disabled-background, light-dark(#afdef8, #515157));
    background: var(--token-component-checkbox-indeterminated-disabled-background, light-dark(#afdef8, #515157));
  }
  .cds-checkbox__checkbox.checkbox--indeterminate.checkbox--disabled
    .cds-checkbox__container
    .cds-checkbox__square
    .cds-icon {
    cursor: not-allowed;
    color: var(--token-component-checkbox-indeterminated-disabled-icon, light-dark(#ffffff, #ffffff));
  }
  .cds-checkbox__checkbox.checkbox--indeterminate.checkbox--readonly
    .cds-checkbox__container
    .cds-checkbox__square {
    border-color: var(--token-component-checkbox-indeterminated-read-only-border, light-dark(#c2c2ca, #515157));
    background: var(--token-component-checkbox-indeterminated-read-only-background, light-dark(#ffffff, #3d3d42));
  }
  .cds-checkbox__checkbox.checkbox--indeterminate
    .cds-checkbox__container
    .cds-checkbox__square
    .cds-icon {
    color: var(--token-component-checkbox-indeterminated-default-icon, light-dark(#ffffff, #343438));
  }
  .cds-checkbox__checkbox.checkbox--indeterminate.checkbox--readonly
    .cds-checkbox__container
    .cds-checkbox__square
    .cds-icon {
    color: var(--token-component-checkbox-indeterminated-read-only-icon, light-dark(#a3a3ab, #83838c));
  }
  .cds-checkbox__checkbox:not(.checkbox--disabled):not(
      .checkbox--readonly
    ):hover
    .cds-checkbox__square {
    border-color: var(--token-component-checkbox-empty-hover-border, light-dark(#009cde, #96cff0));
  }
  .cds-checkbox__checkbox:not(.checkbox--disabled):not(
      .checkbox--readonly
    ):hover
    .cds-checkbox__square
    cds-icon {
    cursor: pointer;
  }
  .cds-checkbox__checkbox:not(.checkbox--disabled):not(
      .checkbox--readonly
    ):active
    .cds-checkbox__square {
    border-color: var(--token-component-checkbox-empty-active-border, light-dark(#0174bc, #5bb3ea));
  }
  .cds-checkbox__checkbox:not(.checkbox--disabled):not(
      .checkbox--readonly
    ).checkbox--checked:hover
    .cds-checkbox__square {
    background: var(--token-component-checkbox-checked-hover-background, light-dark(#009cde, #96cff0));
    border-color: var(--token-component-checkbox-checked-hover-background, light-dark(#009cde, #96cff0));
  }
  .cds-checkbox__checkbox:not(.checkbox--disabled):not(
      .checkbox--readonly
    ).checkbox--checked:active
    .cds-checkbox__square {
    background: var(--token-component-checkbox-checked-active-background, light-dark(#0174bc, #5bb3ea));
    border-color: var(--token-component-checkbox-checked-active-background, light-dark(#0174bc, #5bb3ea));
  }
  .cds-checkbox__checkbox:not(.checkbox--disabled):not(
      .checkbox--readonly
    ).checkbox--indeterminate:hover
    .cds-checkbox__square {
    background: var(--token-component-checkbox-indeterminated-hover-background, light-dark(#009cde, #96cff0));
  }
  .cds-checkbox__checkbox:not(.checkbox--disabled):not(
      .checkbox--readonly
    ).checkbox--indeterminate:active
    .cds-checkbox__square {
    background: var(--token-component-checkbox-indeterminated-active-background, light-dark(#0174bc, #5bb3ea));
  }

  :host-context(.cds-cell) .cds-checkbox__container,
  :host-context(.cds-cell) .cds-checkbox__container > .cds-checkbox__square {
    height: var(--token-global-spacing-s16, 16px);
    width: var(--token-global-spacing-s16, 16px);
    bottom: 1px;
  }

  :host-context(.cds-header-cell) .cds-checkbox__container,
  :host-context(.cds-header-cell)
    .cds-checkbox__container
    > .cds-checkbox__square {
    height: var(--token-global-spacing-s16, 16px);
    width: var(--token-global-spacing-s16, 16px);
  }

  .cds-visually-hidden {
    border: 0;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
    white-space: nowrap;
    outline: 0;
    -webkit-appearance: none;
    -moz-appearance: none;
    left: 0;
  }
`;
